// extracted by mini-css-extract-plugin
module.exports = {"root":"half-module--root--3IkLY","wrapper":"half-module--wrapper--ECt61","title":"half-module--title--Aolgb","text":"half-module--text--2MLY6"};